import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { reducers } from './reducers';
import { ProfileEffects } from './effects/profile';
import * as customFieldsReducer from './reducers/custom-fields';
import * as profileReducer from './reducers/profile';
import * as machinesReducer from './reducers/machines';
import { AttachmentsEffects } from './effects/attachments';
import { CustomFieldsEffects } from './effects/custom-fields';
import { assetsFeature } from './reducers/assets';
import { AssetsEffects } from './effects/assets';
import { NgrxRouterModule } from './modules/router/ngrx-router.module';
import { tenantFeature } from './reducers/tenant';
import { TenantEffects } from './effects/tenant';
import { ColorLegendsEffects } from './effects/color-legends';
import * as colorLegendsReducer from './reducers/color-legends';
import { tableStareDataFeature } from './reducers/table-store-data';
import { TableStoreEffects } from './effects/table-store';
import { SapGlobalEffects } from './effects/sap-global';
import { SapSynchronizationEffects } from './effects/sap-synchronization';
import { SapAssetsEffects } from './effects/sap-assets';

@NgModule({
  imports: [
    StoreModule.forRoot(reducers, {
      runtimeChecks: {
        strictStateImmutability: false,
        strictActionImmutability: false
      }
    }),
    EffectsModule.forRoot([
      ProfileEffects,
      SapGlobalEffects,
      SapSynchronizationEffects,
      SapAssetsEffects
    ]),
    StoreModule.forFeature(tableStareDataFeature),
    StoreModule.forFeature(customFieldsReducer.name, customFieldsReducer.reducer),
    StoreModule.forFeature(profileReducer.name, profileReducer.reducer),
    StoreModule.forFeature(machinesReducer.name, machinesReducer.reducer),
    StoreModule.forFeature(assetsFeature),
    StoreModule.forFeature(tenantFeature),
    StoreModule.forFeature(colorLegendsReducer.name, colorLegendsReducer.reducer),
    EffectsModule.forFeature([
      AttachmentsEffects,
      CustomFieldsEffects,
      AssetsEffects,
      TenantEffects,
      ColorLegendsEffects,
      TableStoreEffects
    ]),
    NgrxRouterModule,
  ],
  exports: [
    StoreModule,
    EffectsModule,
    NgrxRouterModule,
  ]
})
export class AppStoreModule {}
